import { Pipe, PipeTransform } from "@angular/core";
import * as jalalimoment from "jalali-moment";
@Pipe({
  name: "productActiveTimeMode"
})
export class ProductActiveTimeModePipe implements PipeTransform {
  transform(value: Date): string {
    if(value==null)return "";
    let date = new Date(value);
    let now = new Date();
    let months = now.getMonth() - date.getMonth();
    if (months <= 0) return " همین ماه ";
    return `${months} ماه پیش - ${jalalimoment(date.toString()).locale('fa').format('YYYY/M/D')}`;
  }
}
